import React from 'react';
import { connect } from 'react-redux';

class MenuItemQuantitySelection extends React.Component {

    render() {
        return (
            <div className="avoidModalScrollMargin">
                <div className="number-of-dishes-wrapper">
                    <div className="number-of-dishes">
                            <a  onClick={this.props.quantitySubtract} className="number-of-dishes-character plus minus">
                                -
                            </a>
                            <div className="number-of-dishes-character number">
                                <span className="text-span-3">
                                {this.props.quantity} {(this.props.quantity == 1) ? "Eat" : "Eats"}
                                </span>
                            </div>
                            <a onClick={this.props.quantityAdd} className="number-of-dishes-character plus" >
                                +
                            </a>
                    </div>
                </div>
            </div>
        );
    }
};

export default connect()(MenuItemQuantitySelection);